<script setup lang="ts">
import { useSEO } from "~/composables/useSeo";
import { useResumeStore } from "~/stores/useResumeStore";
import { useRoute } from "vue-router";

const resumeStore = useResumeStore();
const route = useRoute();

// Load resume data
await resumeStore.loadResumeData();

if (resumeStore.personalInformation) {
  useSEO({
    title: `${resumeStore.personalInformation.name} - ${resumeStore.personalInformation.title}`,
    description: resumeStore.personalInformation.shortPhrase,
    image: resumeStore.personalInformation.avatar.main,
    url: route.fullPath,
  });
}
</script>
<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <!-- Main Navigation -->
    <UiMainNav>
      <template #title>
        <div class="inline-flex flex-col">
          <UiTitle
            level="1"
            class="text-md leading-5.5 text-primary-900 dark:text-primary-50"
          >
            {{ resumeStore.personalInformation?.name }}
          </UiTitle>
          <UiTitle
            level="2"
            class="text-xs leading-5.5 text-primary-900 dark:text-primary-50"
          >
            {{ resumeStore.personalInformation?.title }}
          </UiTitle>
        </div>
      </template>
    </UiMainNav>

    <!-- Main Content -->
    <main
      class="lg:pt-16 lg:container mx-auto bg-white dark:bg-primary-950 shadow-2xl border-x border-gray-200 dark:border-primary-900 min-h-screen overflow-x-clip"
    >
      <slot />
    </main>
  </div>
</template>
